import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from '../../styles';
import { useSportConfig } from '../../../../hooks/useSportConfig';

const EnteredIntoPrizeDraw = ({ eventName, prize }) => {
    const { config } = useSportConfig();
    const { selectionNoun } = config.labels;
    const { eventNoun } = config.labels;

    return (
        <>
            <Styled.Heading>You&#39;re in the Prize Draw!</Styled.Heading>
            <Styled.Text>
                Your {selectionNoun} won the {eventName} {eventNoun}. You have
                now been entered into the{' '}
                <Styled.Highlighted>Prize Draw</Styled.Highlighted> to win{' '}
                <Styled.Highlighted>{prize}!</Styled.Highlighted>
            </Styled.Text>
        </>
    );
};

EnteredIntoPrizeDraw.propTypes = {
    eventName: PropTypes.string.isRequired,
    prize: PropTypes.string.isRequired
};

export default EnteredIntoPrizeDraw;
